<template>
	<div>
		<div class="nutnosti-title">UVT:</div>
		<div v-if="!loading">
			<div v-if="results.failed">
				{{ results.message }}
			</div>

			<!-- {{ results }} -->
			<div v-else>
				<span style="font-size: 22px; font-weight: bold; color: gray; margin-top: 5px; margin-bottom: 10px">
					Doporučené produkty:
				</span>
				<div class="uvt-recommended">
					<div class="cetin-vysledek-card" style="display: flex; flex-direction: column;" v-for="(item, index) in results.recommended_tariffs" :key="index">
						<span>
							Technologie:
							<span style="font-weight: bold;">
								{{ item.technology }}
							</span>
						</span>
						<span>
							Jméno:
							<span style="font-weight: bold;">
								{{ item.name }}
							</span>
						</span>
						<span>
							Cena(vč. DPH):
							<span style="font-weight: bold;">
								{{ item.price }}
							</span>
						</span>
						<span>
							Download:
							<span style="font-weight: bold;">
								{{ item.download }}
							</span>
						</span>
						<span>
							Upload:
							<span style="font-weight: bold;">
								{{ item.upload }}
							</span>
						</span>
						<span>
							Dostupnost:
							<span style="font-weight: bold;">
								{{ item.feasibility }}
							</span>
						</span>
						<span>
							Aktivace:
							<span style="font-weight: bold;">
								{{ item.extra_parameters.activation }}
							</span>
						</span>
						<span>
							Veřejná IP:
							<span style="font-weight: bold;">
								{{ item.extra_parameters.public_ip }}
							</span>
						</span>
					</div>
				</div>
				<span style="font-size: 22px; font-weight: bold; color: gray; margin-top: 5px; margin-bottom: 10px">
					CETIN:
				</span>
				<div v-for="(item) of results.in_areas" :key="item.name" v-if="item.name === 'CETIN'" style="display: flex; flex-direction: column; background-color: white; border-radius: 5px; padding: 10px; max-width: 500px; flex-wrap: wrap;">
					<div v-for="itemTwo of item.tariffs" :key="itemTwo.name">
						{{ itemTwo.technology }} - {{ `${itemTwo.download} / ${itemTwo.upload}` }} - {{ feasibilityDict[itemTwo.feasibility] }}
					</div>
				</div>
				<div v-else style="display: flex; flex-direction: column; background-color: white; border-radius: 5px;">

				</div>
			</div>
		</div>
		<div v-else>
			<tile
				:loading="loading"
				:height="'4'"
				:width="'4'"
				class="loading-icon"
			></tile>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OrelSoftResult',

	props: {
		results: { type: Boolean },
		loading: { type: Boolean },
	},

	data() {
		return {
			showUVT: true,
			feasibilityDict: {
				'available': 'Dostupné ihned',
				'connection': 'CETIN musí objekt dopojit ve své režii',
				'investment': 'dostupné, ale je nutná finanční spoluúčast klienta'
			},
			typeDict: {
				'fastest': 'Nejrychlejší',
				'cheapest': 'Nejlevnější',
				'our_choice': 'Naše volba',
			}
		}
	},

	methods: {},
}
</script>

<style lang="stylus" scoped>
.nutnosti
	display flex
	flex-direction column

.nutnosti-title
	margin-top 20px
	font-size 24px
	font-weight bold
	border-top 1px solid #4CA5F9

.cetin-vysledek-card
	padding 10px
	background-color white
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

.zmensit
	width 400px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important

.uvt-recommended
	display flex
	flex-direction row

@media (max-width 1000px)
	.zmensit
		width 100%

	.uvt-recommended
		flex-direction: column
</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/UVTResult.vue